import React, { useEffect, useRef, useState } from "react";
import { Box, Tooltip, Typography } from "@mui/material";

// Const
import { formLimitation } from 'const';

const EllipsisTooltipCell = ({ text }) => {
  const textRef = useRef(null);
  const [isOverflow, setIsOverflow] = useState(false);

  useEffect(() => {
    const element = textRef.current;
    if (element) {
      setIsOverflow(element.scrollWidth > element.clientWidth);
    }
  }, [text]);

  return (
    <Tooltip
      title={
        isOverflow
          ? (
            <Typography sx={{ whiteSpace: "normal" }}>
              {text || "-"}
            </Typography>
          )
          : ""
      }
      disableHoverListener={!isOverflow}
      arrow
    >
      <Box
        ref={textRef}
        sx={{
          width: "100%",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {text || "-"}
      </Box>
    </Tooltip>
  );
};

export const getTableColumns = (columnHelper) => {
  return [
    columnHelper.accessor('profileName', {
      header: 'Profile Name',
      meta: {
        disableAutoExtend: true,
      },
      size: 260,
      enableSorting: false,
      cell: info => (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <EllipsisTooltipCell text={info.getValue()} />
        </Box>
      )
    }),
    columnHelper.accessor('deviceCategory.props.id', {
      header: 'Device Type',
      meta: {},
      cell: info => (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          {info.getValue()}
        </Box>
      )
    }),
    columnHelper.accessor('portState', {
      header: 'Port State',
      meta: {},
      enableSorting: false,
      cell: info => (
        // Enumeration display: enabled, disabled, scheduled(TODO)
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          {info.getValue() ? "Enabled" : "Disabled"}
        </Box>
      )
    }),
    columnHelper.accessor('pvid', {
      header: 'PVID',
      meta: {},
      enableSorting: false,
      cell: info => (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          {info.getValue()}
        </Box>
      )
    }),
    columnHelper.accessor('allowVlan', {
      header: 'Allow VLANs',
      meta: {},
      enableSorting: false,
      cell: info => (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          {info.getValue()}
        </Box>
      )
    }),
    columnHelper.accessor('assignedPortLength', {
      header: 'Assigned Ports',
      meta: {},
      enableSorting: false,
      cell: info => (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          {info.getValue()}
        </Box>
      )
    }),
  ]
}

export const parseVlanRangeString = (input) => {
  if (typeof input !== "string") return [];

  const result = new Set();
  const parts = input.split(",").map(s => s.trim());
  const { min, max } = formLimitation.vlanId;

  for (const part of parts) {
    if (part === "") continue;

    if (part.includes("-")) {
      const [startStr, endStr] = part.split("-").map(s => s.trim());
      const start = parseInt(startStr, 10);
      const end = parseInt(endStr, 10);

      if (
        isNaN(start) || isNaN(end) ||
        start < min || end > max ||
        start > end
      ) {
        continue;
      }

      for (let i = start; i <= end; i++) {
        result.add(i);
      }

    } else {
      const num = parseInt(part, 10);
      if (!isNaN(num) && num >= min && num <= max) {
        result.add(num);
      }
    }
  }

  return [...result].sort((a, b) => a - b);
};